// extracted by mini-css-extract-plugin
export default {"TabItem":"TabItem_TabItem__GX3nC","TabItem_active":"TabItem_TabItem_active__MBU7H"};